<template>
  <v-dialog
    v-model="dialog"
    persistent
    :max-width="options.width"
    @keydown.esc="cancel"
    v-bind:style="{zIndex: options.zIndex}"
    :fullscreen="$vuetify.breakpoint.mobile"
  >
    <baseModal>

      <v-btn
        v-if="!isAutoInput"
        slot="positive-button"
        dark text class="orange--text text-h6 font-weight-bold" @click.native="agree">등록</v-btn>

      <v-btn
        v-if="index > -1 && !isAutoInput"
        slot="func-button"
        dark text class="pink--text text--lighten-2 text-h6" @click.native="remove">삭제</v-btn>

      <v-btn
        slot="negative-button"
        dark text class="white--text subheading" @click.native="cancel">취소</v-btn>

      <v-checkbox
        v-if="index > -1"
        slot="func-option"
        v-model="addLimitDay"
        dense
        label="기한추가"
        class="mt-3"
      ></v-checkbox>

      <v-btn
        slot="star-area"
        icon
        @click.native="form.isStar = !form.isStar"
      >
        <v-icon
          v-if="!form.isStar"
          color="grey lighten-1"
        >
          mdi-star-outline
        </v-icon>
        <v-icon
          v-else
          color="yellow"
        >
          mdi-star
        </v-icon>
      </v-btn>

      <v-toolbar-title
        slot="title-area"
        class="white--text">{{ title }}</v-toolbar-title>

      <!-- 중요: 상단 툴바 타이틀을 고정시키기 위해 아래처럼 v-card에 max-height를 주면 된다 -->
      <!-- <v-card
        slot="content"
        tile
        elevation="0"
        class="overflow-y-auto py-2 px-3"
        :max-height="options.height"
      >
        <v-card-text> -->

      <!-- 상단 툴바를 고정시키지 않으려면 아래 주석을 푼다. 하단의 태그 끝에도 주석을 풀어야 한다. -->
      <v-card-text
        slot="content"
        class="pb-0"
      >
        <v-container fluid class="pb-0"><!-- 여기까지 적용 -->

          <v-row no-gutters>
            <v-col cols="12" xs="12">
              <v-text-field
                v-model.trim="article.teamName"
                label="담당부서"
                readonly
              >
                <template v-slot:prepend>
                  <v-icon
                    :color="article.teamColorOrigin"
                  >mdi-account-group</v-icon>
                </template>
              </v-text-field>
            </v-col>
            <v-col cols="12" xs="12">
              <v-menu
                ref="date1Selector"
                v-model="date1Selector"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model.trim="form.date1"
                    label="발송일자"
                    prepend-icon="event"
                    readonly
                    v-on="on"
                    style="width: 200px;"
                  ></v-text-field>
                </template>
                <v-date-picker
                  ref="picker"
                  v-model="form.date1"
                  locale="ko"
                  @change="saveDate1"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" xs="12">
              <v-text-field
                v-model.trim="form.str1"
                v-validate="'required|max:50'"
                :error-messages="errors.collect('str1')"
                data-vv-name="str1"
                maxlength="50"
                counter="50"
                required
                label="발송내용*"
                hint="예)원고대리인 홍길동에게 판결정본 발송(공시송달)"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="4">
              <v-menu
                ref="date2Selector"
                v-model="date2Selector"
                :close-on-content-click="false"
                transition="scale-transition"
                offset-y
                min-width="290px"
              >
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model.trim="form.date2"
                    label="도달일자"
                    prepend-icon="event"
                    v-on="on"
                    style="width: 200px;"
                  ></v-text-field>
                </template>
                <v-date-picker
                  ref="picker2"
                  v-model="form.date2"
                  locale="ko"
                  @change="saveDate2"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" xs="12" sm="5">
              <v-text-field
                v-model.trim="form.str2"
                maxlength="20"
                counter="20"
                label="발송결과"
                hint="예)도달, 폐문부재"
                :disabled="isGongsiSongdal"
                class="ml-4"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="3">
              <v-switch
                v-model="isGongsiSongdal"
                color="primary"
                label="공시송달"
                class="mt-5 ml-6"
                @change="gongsiSongdal"
              ></v-switch>
            </v-col>
            <v-col cols="12" xs="12">
              <v-alert
                border="left"
                outlined
                type="info"
                dense
                class="text-body-2"
              >
                {{ article.courtName }} {{ article.caseNum }}{{ article.manageNum ? `/${article.manageNum}` : '' }}
                <v-tooltip color="info" bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      v-on="on"
                      small color="primary lighten-2"
                      @click="gotoDetail"
                      class="ml-1"
                    >mdi-launch</v-icon>
                  </template>
                  <span>바로가기</span>
                </v-tooltip>
              </v-alert>
            </v-col>
            <!-- <v-col cols="12" v-show="index > -1" class="py-0">
              <v-card
                tile
                elevation="0"
                class="ma-0 pa-0"
              >
                <v-card-actions class="ma-0 pa-0">
                  <v-btn small text icon color="primary" disabled>
                    <v-icon small>print</v-icon>
                  </v-btn>
                  <v-btn small text icon color="primary" disabled>
                    <v-icon small>get_app</v-icon>
                  </v-btn>
                  <v-btn small text icon color="primary" disabled>
                    <v-icon small>phone_iphone</v-icon>
                  </v-btn>
                  <v-btn small text icon color="primary" disabled>
                    <v-icon small>local_post_office</v-icon>
                  </v-btn>
                  <v-spacer></v-spacer>
                  <span class="text-caption mr-2">{{ viewWname }}</span><span class="text-caption">{{ viewUpdatedAt }}</span>
                </v-card-actions>
              </v-card>
            </v-col> -->
            <v-col cols="12">
              <div class="mb-8"></div>
            </v-col>

          </v-row>

        <!-- 상단 타이틀 고정을 풀때 사용 -->
        </v-container>
      </v-card-text>

        <!-- 상단 타이틀 고정시 사용 -->
        <!-- </v-card-text>
      </v-card> -->

    </baseModal>

  </v-dialog>
</template>

<script>
import ko from 'vee-validate/dist/locale/ko'
import baseModal from '@/components/common/BaseModal' // 기본 다이얼로그
import strDateFormat from '@/filters/strDateFormat'

export default {
  components: {
    baseModal
  },

  props: [ 'article' ],

  $_veeValidate: {
    validator: 'new'
  },

  data: () => ({
    // 구분: 다이얼로그 관련
    dialog: false,
    resolve: null,
    reject: null,
    title: null,
    options: {
      color: 'primary',
      width: 770,
      height: 750,
      zIndex: 200
    },
    // 구분: Form 관련
    form: {
      id: 0,
      teamId: 1, // 기본팀이 초기값
      type: 21, // 중요: 유형 - 진행내용
      depth: 2,
      pId: 0,
      pType: 1, // 중요: 부모타입 = 소송
      pInfo: '', // 정보위치(부모의 정보 중 보여줄 정보)
      isStar: 0,
      isSchedule: 1,
      subtype: 5, // 중요: 기본값 = 송달(5)
      gubun1: '', // 타이틀 = 송달
      status: 1,
      date1: '', // 발송일자
      date2: '', // 도달일자
      str1: '', // 발송내용
      str2: '', // 발송결과
      parentInfo: '' // [2021.3.23] 부모정보 문자열
    },
    // !!구분: 팝업을 열면서 넘어온 subtype 을 매칭시켜야 한다!
    subType: 5,
    // 구분:
    index: -1, // !! 수정 인덱스
    // 구분: _veeValidate dictionary
    dictionary: {
      messages: ko.messages,
      attributes: {
        str1: '위 '
      }
    },
    // 구분: 입력 검증
    rules: {
      txtCounter: v => v.length <= 200 || '200자 이하의 내용을 입력해 주세요'
    },
    // 구분: 일자 - 시간
    date1Selector: false, // 발송일자 셀렉터
    date2Selector: false, // 도달일자 셀렉터
    // 구분: 수정시 처리자와 최종업데이트 정보
    viewWname: '',
    viewUpdatedAt: '',
    // 구분: 자동입력 데이터인 경우
    isAutoInput: false,
    // 구분: 송달에서만 쓰이는 공시송달 여부
    isGongsiSongdal: false,
    // 구분: 기한추가 체크박스
    addLimitDay: false
  }),

  mounted () {
    this.$validator.localize('ko', this.dictionary)
  },

  methods: {
    dummy () {
      console.log('dummy test')
    },
    sbpop (e) {
      // 서버에서 수신받은 에러는 router 에서 가로채기 하므로 띄우지 않도록 if (!e.response) 를 검사한다.
      if (!e.response) this.$store.commit('SB_POP', { msg: e.message })
    },
    // !!중요: 재귀적으로 부모의 $refs 를 탐색하여 target 객체를 찾아 리턴한다.
    // 주로 팝업을 검색하는데 사용!
    async findParentRefs (parent, target) {
      try {
        for (let key in parent.$refs) {
          if (key === target) { // 찾은경우
            return parent.$refs[key]
          }
        }
        // 못찾은 경우 - 부모가 또 있으면 올라간다.
        if (parent.$parent) {
          return await this.findParentRefs(parent.$parent, target)
        } else {
          return null // 못찾으면 null 리턴
        }
      } catch (e) {
        this.sbpop(e)
      }
    },
    // 초기화
    async initDialog () {
      // validation 초기화
      this.$validator.reset()

      this.form.id = 0
      this.form.teamId = 1 // 기본팀을 기본값으로
      this.form.subtype = this.subType // 중요: 넘어온 subtype 을 매칭한다!
      this.form.pId = 0 // 부모 아이디
      this.form.pType = 1 // 중요: 부모 타입 = 소송
      this.form.pInfo = '' // 정보위치(부모의 정보 중 보여줄 정보)
      this.form.gubun1 = this.title // !! 넘어온 상단의 제목이 gubun1 이 된다!
      this.form.status = 1
      this.form.isStar = 0
      this.form.isSchedule = 1 // 일정표시여부
      this.form.date1 = this.$moment().format('YYYY-MM-DD') // 일시 초기값(오늘)
      this.form.date2 = '' // 도달일자 초기값은 없음
      this.form.str1 = '' // 발송내용
      this.form.str2 = '' // 발송결과
      this.form.parentInfo = ''

      this.isAutoInput = false
      this.addLimitDay = false // 기한추가 체크박스 초기화

      this.index = -1 // 수정용 인덱스 초기화

      this.isGongsiSongdal = false
    },

    async open (title, options, subtype, index = -1, obj = {}) {
      try {
        this.dialog = true
        this.title = title
        this.options = Object.assign(this.options, options)

        // 중요: 파라미터로 넘어온 subtype 에 따라 기일/기한이 결정되므로 중요하다
        this.subType = subtype

        // console.log(this.article) // !! props 로 넘어온 부모 데이터

        // 초기화
        await this.initDialog()

        // !! 아래 3개는 부모로부터 넘겨받은 데이터로 매칭하자(뭐 이렇게 하지 않아도 되는데)
        this.form.teamId = this.article.teamId
        this.form.pId = this.article.id

        // 중요:[2021.3.23] 소송정보를 부모정보로 넘기기 위해
        this.form.parentInfo = this.article.caseNum

        // 중요:[2021.3.22 수정] 부모정보의 객체를 문자열로 변환해서 this.form.pInfo 에 담는다.
        this.form.pInfo = JSON.stringify(this.article.pInfo)

        // 참고: 편집 모드인 경우 - 넘어온 객체를 this.form 에 복사
        if (index > -1) {
          // console.log(obj) // 파라미터로 넘어온 업무
          this.index = index

          this.form.id = obj.id

          this.form.gubun1 = obj.gubun1 // 구분 타이틀 = 송달
          this.form.status = obj.status
          this.form.subtype = obj.subtype // !! 이미 초기화에서 적용했으므로 의미는 없는데?
          this.form.isStar = obj.isStar

          // !! 진행내용에선 의미 없지만 일단 놔둔다.
          // 등록과 같은 자동입력 데이터는 유형을 재조정 - 유형재조정은 포기
          if (obj.subtype === 0) {
            this.isAutoInput = true // 자동입력 데이터임을 표시
          }

          this.form.str1 = obj.str1 // 발송내용
          this.form.str2 = obj.str2 // 발송결과
          if (obj.str2 === '0시 도달') {
            this.isGongsiSongdal = true
          }

          // 일자-시간 처리
          this.form.date1 = obj.date1.substr(0, 10) // 발송일자
          if (obj.date2) {
            // 도달일자가 있는 경우만 처리
            this.form.date2 = obj.date2.substr(0, 10)
          }

          // 참고: 편집일때는 처리자와 업데이트 일자를 보여준다.
          this.viewWname = obj.wname
          this.viewUpdatedAt = strDateFormat(obj.updatedAt) // 필터로 쓰진 않고 함수로 사용
        }

        // 프로미스를 리턴하면서 resolve를 매칭하고있다.
        return new Promise((resolve, reject) => {
          this.resolve = resolve
          this.reject = reject
        })
      } catch (e) {
        this.sbpop(e)
      }
    },
    // 등록/수정
    async agree () {
      try {
        // 참고: 입력값 검증
        let isValidate = await this.$validator.validateAll()
        if (!isValidate) throw new Error('입력값을 확인해 주세요')

        // 기한추가에 체크했는데 도달일이 없는 경우 경고
        if (this.addLimitDay && !this.form.date2) throw new Error('기한추가를 하시려면 도달일자를 입력해야 합니다.')

        // !! 발송일자 - 현재 시분초로
        // this.form.date1 = `${this.form.date1.substr(0, 10)} ${this.$moment().format('HH:mm:ss')}`
        // !!중요:[2021.4.8] 발송일자 수정 - 00:07:01 로 변경
        this.form.date1 = `${this.form.date1.substr(0, 10)} 00:07:01`

        // 고쳐:!! 도달일자는 있는 경우만 처리
        // 공시송달의 경우 '0시 도달'로 처리해야 하는데... 상관없다 공시송달이나 일반송달이나 똑같이 00:00:01 로 한다.
        // 도달일자는 일정에서 도달일로 검색할 때 사용된다!
        if (this.form.date2) {
          this.form.date2 = `${this.form.date2.substr(0, 10)} 00:00:01`
        } else {
          this.form.date2 = null
        }

        // !! 돌려주는 객체
        let resolve = {
          isDeleted: false, // 부모가 삭제되었는지 여부
          teamError: false, // 부모의 팀에러
          chInfo: null, // 부모의 에러가 있는 경우 채워지는 객체
          rsMsg: '' // resolve 메시지
        }

        // !! DB 입력 처리 (등록/수정 동일하게 처리)
        const { data } = await this.$axios.post(`lawork/case/setUpmuContent`, this.form)
        if (!data.success) throw new Error(`오류가 발생하였습니다: ${data.message}`)
        // 리턴값으로 resolve 채우기
        resolve.isDeleted = data.isDeleted
        resolve.teamError = data.teamError
        resolve.chInfo = data.chInfo
        resolve.rsMsg = 'edited'
        // !! 기한추가인 경우 도달일을 리턴한다
        if (this.addLimitDay) {
          if (!this.form.date2) throw new Error('기한추가를 하시려면 도달일자를 입력해야 합니다.') // 한번 더 체크
          // 도달일(기준일)과 공시송달여부를 객체형식으로 만들어서 리턴한다.
          resolve.rsMsg = { stdDay: this.form.date2.substr(0, 10), isGongsiSongdal: this.isGongsiSongdal }
        }

        // // !! 기한추가인 경우 도달일을 리턴한다.(기본은 'success' 리턴)
        // let returnResult = 'success'
        // if (this.addLimitDay) {
        //   if (!this.form.date2) throw new Error('기한추가를 하시려면 도달일자를 입력해야 합니다.') // 한번 더 체크
        //   // 도달일(기준일)과 공시송달여부를 객체형식으로 만들어서 리턴한다.
        //   returnResult = { stdDay: this.form.date2.substr(0, 10), isGongsiSongdal: this.isGongsiSongdal }
        // }

        // 등록 후
        await this.initDialog()
        this.resolve(resolve) // !!this.resolve(returnResult)
        this.dialog = false
      } catch (e) {
        this.sbpop(e)
      }
    },
    // 취소
    async cancel () {
      try {
        await this.initDialog() // 초기화
        this.resolve(false) // reject() 가 아니라 resolve(false)로 던져야 한다.
        this.dialog = false
      } catch (e) {
        this.sbpop(e)
      }
    },
    // 삭제
    async remove () {
      try {
        if (!this.form.id) throw new Error(`잘못된 요청입니다.`)

        // 중요: 재귀적으로 부모의 $refs 에서 팝업 컴포넌트 객체를 얻는다.
        const target = 'confirmDialog'
        const pop = await this.findParentRefs(this.$parent, target)
        if (!pop) throw new Error('팝업창을 열 수 없습니다.')
        // 찾았으면 팝업을 연다
        const msg = `정말 삭제하시겠습니까?<br>삭제된 데이터는 복구되지 않습니다.`
        if (await pop.open('삭제', msg, { color: 'error', width: 400 })) {
          // !! 돌려주는 객체
          let resolve = {
            isDeleted: false, // 부모가 삭제되었는지 여부
            teamError: false, // 부모의 팀에러
            chInfo: null, // 부모의 에러에 대한 메시지
            rsMsg: '' // resolve 메시지
          }
          const { data } = await this.$axios.post(`lawork/case/deleteUpmuContent`, this.form)
          if (!data.success) throw new Error(`오류가 발생하였습니다: ${data.message}`)
          // 리턴값으로 resolve 채우기
          resolve.isDeleted = data.isDeleted
          resolve.teamError = data.teamError
          resolve.chInfo = data.chInfo
          resolve.rsMsg = 'removed' // 삭제됨

          await this.initDialog() // 초기화
          this.resolve(resolve) // tthis.resolve(true)
          this.dialog = false
        }
      } catch (e) {
        this.sbpop(e)
      }
    },
    // !! 발송일자 셀렉트 선택시 저장 함수
    saveDate1 (date) {
      this.$refs.date1Selector.save(date)
    },
    // !! 도달일자 셀렉트 선택시 저장 함수
    saveDate2 (date) {
      this.$refs.date2Selector.save(date)
    },
    // 공시송달 처리
    gongsiSongdal () {
      try {
        if (this.isGongsiSongdal) {
          // 공시송달인 경우 0시 도달
          this.form.str2 = '0시 도달'
          this.form.str1 = `${this.form.str1}(공시송달)`
        } else {
          this.form.str2 = ''
          this.form.str1 = this.form.str1.replace(/\(공시송달\)/gi, '')
        }
      } catch (e) {
        this.sbpop(e)
      }
    },
    // !! 상세페이지 바로가기
    gotoDetail () {
      this.dialog = false
      // !! 현재 경로가 case 디렉토리가 아닌 경우만 case/ 로 이동시킨다
      if (!(this.$router.history.current.path.indexOf('case') !== -1)) {
        this.$router.push(`/case/${this.article.id}`)
      }
    }
  }
}
</script>
